// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"quote-module--quoteWrapper--1y6r-","quote":"quote-module--quote--2-oW3","quoteSign":"quote-module--quoteSign--2J96l","errorpage":"quote-module--errorpage--gOEda"};